import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ConnectionServiceModule } from 'ng-connection-service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { createErrorHandler } from '@sentry/angular';
import { APP_ROUTES } from './app.routes';
import { cdnUrlInterceptor } from './core/interceptor/cdn-url.interceptor';
import { savingInterceptor } from './core/interceptor/saving.interceptor';
import { CdnUrlService } from './shared/services/cdn-url.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([cdnUrlInterceptor, savingInterceptor])),
    provideAnimations(),
    // MatDatepicker needs a DateAdapter (previously supplied by MatNativeDateModule).
    provideNativeDateAdapter(),
    importProvidersFrom(ConnectionServiceModule),
    NgSelectConfig,
    // Rewrite legacy asset URLs in browser storage before the app starts.
    provideAppInitializer(() => inject(CdnUrlService).rewriteBrowserStorage()),
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({ showDialog: false }),
    },
  ],
};
